import { Box, Button, Container, Grid, Link, Typography } from "@mui/material";
import i18next from "i18next";

export interface ReferredProps {
  getFile: (fileName: string) => string;
}

export const Referred = ({ getFile }: ReferredProps) => {
  return (
    <>
      <Grid size={12}>
        <Typography align="center" variant="h2">
          {i18next.t("corporatePrograms")}
        </Typography>
      </Grid>
      <Grid sx={{ marginTop: "20px" }} size={12}>
        <Box style={{ backgroundColor: "white" }}>
          <Grid container spacing={3}>
            <Grid size={12}>
              <Typography align="center" variant="h3">
                {i18next.t("coderlandAmbassador")}
              </Typography>
            </Grid>
            <Grid size={12}>
              <Box sx={{ display: "flex", justifyContent: "center" }}>
                <img src={getFile("03_PP_referidos.png")} style={{ width: "80%" }} />
              </Box>
            </Grid>
            <Grid size={12}>
              <Typography align="center" variant="h4">
                {i18next.t("programReferred")}
              </Typography>
            </Grid>
            <Grid sx={{ marginBottom: "20px" }} size={12}>
              <Container maxWidth="md">
                <Typography align="center" variant={"p" as "body1"}>
                  {i18next.t("benefitsCoderlandAmbassador")}
                  <b>{i18next.t("secondBenefitsCoderlandAmbassador")}</b>
                </Typography>
              </Container>
            </Grid>
            <Grid sx={{ marginBottom: "20px" }} size={12}>
              <Container maxWidth="md">
                <Button
                  component={Link}
                  target="_blank"
                  rel="noreferrer"
                  href="#/gestion-de-vacantes/vacantes"
                  underline="none"
                >
                  {i18next.t("vacanciesAvailable")}
                </Button>
              </Container>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    </>
  );
};
